'use client';
import * as React from 'react';
import { Control, Controller } from 'react-hook-form';
import { FormCard } from '../../../ui/shared';
import { Profile } from '../../types/profile';
import { FormControlLabel, Switch, Typography } from '@mui/material';
import { Profile as DictProfile } from '@/shared/i18n';

const notificationOptions: (dict: DictProfile['profile']) => {
  label: string;
  key: keyof Pick<Profile, 'notificationsNews' | 'notificationsPromotions' | 'notificationsRenew'>;
}[] = (dict) => [
  { label: dict.notifications_news_and_updates, key: 'notificationsNews' },
  { label: dict.notifications_promotions, key: 'notificationsPromotions' },
  // { label: 'Aggiornamenti della community',  },
  { label: dict.notifications_renewal_notices, key: 'notificationsRenew' },
];

interface NotificationSettingsProps {
  control: Control<Profile>;
  dict: DictProfile['profile'];
}

const NotificationSettings: React.FC<NotificationSettingsProps> = ({ control, dict }) => (
  <FormCard title="Notifiche">
    <div className="flex flex-col md:flex-row flex-wrap gap-x-10 gap-y-4 md:items-center w-full">
      {notificationOptions(dict).map(({ label, key }) => (
        <Controller
          name={key}
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch color="primary" {...field} checked={!!field.value} value={!!field.value} />
              }
              label={
                <Typography variant="button-m" className="font-semibold">
                  {label}
                </Typography>
              }
              key={key}
            />
          )}
          key={`${key}-controller`}
        />
      ))}
    </div>
  </FormCard>
);

export default NotificationSettings;
